import React from 'react'
import "./Home.css";

const Home = () => {
  return (
    <div className='home container'>
        <div className='home-text'>
            <h1>Explore the world of Science and Technology with AI</h1>
            <p>"Explore the world of science and technology powered by AI with us. Discover innovation, smart solutions, and future-ready technologies transforming everyday life. Stay informed, inspired, and connected to the advancements shaping a smarter, more intelligent world."</p>
            {/* <button className='btn'>Explore more <FontAwesomeIcon icon={faArrowRight}/></button> */}
        </div>
    </div>
  )
}

export default Home
